import React, { useState, useEffect } from "react";
import Layout from "../../components/layout/Layout";
import { useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Table } from "../../components/table/Table";
import { Spinner } from "../../components/spinner";
import { useGetDynamicQR } from "../../hooks/useDynamicQR";
import { useQueryTransaction } from "../../hooks/useTransaction";
import { reversePaymentMethods } from "../../utils/constants/paymentMethods";
import { formatCurrency, formatDateTime, truncateName } from "../../utils/functions";
import storage from "../../utils/storage";
import { Notify } from "../../components/notification";

import "./styles.scss";
import { SpinnerWhite } from "../../components/spinner/Spinner";

const column = [
  "Amount",
  "Payment method",
  "Station name",
  "Customer name",
  "Date",
];

export const AcceptPaymentPage = () => {
  const history = useHistory();
  const cusId = JSON.parse(storage.fetch("onboardingDetails")).cusId;
  const [amount, setAmount] = useState(0);
  const [transactions, setTransactions] = useState([]);
  const [subMchNo, setSubMchNo] = useState("");
  const [merchantName, setMerchantName] = useState("");
  const [merchantNumber, setMerchantNumber] = useState("");

  const {
    isLoading: isFetchingTransaction,
    data: transactionData,
    mutate: fetchTransactions,
  } = useQueryTransaction({
    cusId,
    pageSize: 5,
  });

  const {
    isLoading: isFetching,
    data: qrCodeData,
    mutate: fetchQRCodeDetails,
  } = useGetDynamicQR({
    merchantName,
    merchantNumber,
    subMchNo,
    cusId,
    amount,
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const resetState = () => {
    setAmount("");
  };

  useEffect(() => {
    const onboardingDetails = JSON.parse(storage.fetch("onboardingDetails"));

    if (onboardingDetails.onboarded) {
      const subMchNo = JSON.parse(
        storage.fetch("merchantDetails")
      ).subMerchantNumber;
      const merchantName = JSON.parse(
        storage.fetch("merchantDetails")
      ).merchantName;
      const merchantNumber = JSON.parse(
        storage.fetch("merchantDetails")
      ).merchantNumber;
      setSubMchNo(subMchNo);
      setMerchantName(merchantName);
      setMerchantNumber(merchantNumber);
      fetchTransactions();
    } else {
      history.push("/dashboard/merchant/onboarding");
      Notify(
        "info",
        "Onboarding pending",
        "Please complete the onboarding process to start using your DeemPay account!",
        10
      );
    }
  }, []);

  useEffect(() => {
    if (transactionData?.code === "000000") {
      const formattedTransactions = transactionData.data.result.map((t) => {
        return {
          payAccountName: truncateName(t.payAccountName),
          tradeAmt: formatCurrency(t.tradeAmt),
          terminalName:
            t.terminalName === null ? "Main account" : t.terminalName,
          productCode: reversePaymentMethods.get(t.productCode),
          finishTime: formatDateTime(t.finishTime),
          orderNo: t.orderNo,
        };
      });
      setTransactions(formattedTransactions);
    }
  }, [transactionData]);

  useEffect(() => {
    if (qrCodeData?.code === "000000") {
      const qrCode = qrCodeData?.data?.qrInfo;
      const orderNo = qrCodeData?.data?.orderNo;
     if(orderNo !== null) {
      history.push(
        `/dashboard/merchant/accept-payment/dynamic/${qrCode}?amount=${amount}&orderNo=${orderNo}`
      );
      resetState();
     }
    } else if (qrCodeData?.code === "999999") {
      Notify(
        "error",
        "Charge error",
        "Sorry! there was a error, please try again.",
        10
      );
    }
  }, [qrCodeData]);

  useEffect(() => {
  }, [subMchNo, merchantName, merchantNumber, amount]);

  const onSubmit = (data) => {
    setAmount(Number(data.amount));
    if (subMchNo && merchantName && merchantNumber) {
      fetchQRCodeDetails();
    }
  };

  const checkTransaction = () => {
    
    if (navigator.onLine) {
      setTransactions([]);
      fetchTransactions();
      } else {
        Notify(
          "error",
          "Network Error!",
          "Please check your internet connection!",
          10
        );
      }
  };   

  return (
    <Layout>
      <header>
        <main className="main__collect">
          <h1 className="collect--pay">Receive Payment</h1>
          <section>
            <form className="charge__form" onSubmit={handleSubmit(onSubmit)}>
              <div className="collect-line">
                <h4>Receive</h4>
              </div>
              <div className="amount--card">
                <label>Amount</label>
                <input
                  className={`input ${errors.amount && "invalid"}`}
                  type="number"
                  placeholder="e.g 100"
                  {...register("amount", {
                    required: "Enter an amount",
                    required: "charge amount is required",
                    minLength: {
                      value: 2,
                      message: "minimum allowed amount is NGN 10",
                    },
                    maxLength: {
                      value: 8,
                      message: "maximum allowed amonut is NGN 50,000,000",
                    },
                  })}
                />
                {errors.amount && (
                  <p className="error__mssg">{errors.amount.message}</p>
                )}
                <h5 className="enter__amount">
                  Enter amount you want to be paid
                </h5>
                <button
                  type="submit"
                  disabled={isFetching}
                  className="chargE"
                >
                  {isFetching ? <SpinnerWhite /> : "Charge"}
                </button>
              </div>
            </form>
          </section>
          <div className="collect--payment">
            <h3>Recent Transactions</h3>
            <div className="top__bar">
              <span className="top-notify">
                <div className="mini-pay" onClick={checkTransaction}>
                  <span className="check_trans">Check Transactions</span>
                </div>
              </span>
            </div>
          </div>
          
          <div className="transactionTable">
            <Table
              column={column}
              data={transactions}
              link={"/dashboard/merchant/transactions/"}
            />
            {isFetchingTransaction ? (
              <>
                <div style={{ marginTop: "40px" }}>
                  <Spinner color={"#1a71ff"} />
                </div>
              </>
            ) : (
              ""
            )}
          </div>
        </main>
      </header>
    </Layout>
  );
};

